export const networkStatus = {
  RUNNING: 0,
  PAUSED: 1,
  TERMINATED: 13
};
